var map = {
	"./fig01.jpg": "a364",
	"./fig02.jpg": "1afd",
	"./fig03.jpg": "2e85",
	"./fig04.jpg": "2b66",
	"./fig05.jpg": "c09b",
	"./fig06.jpg": "9996",
	"./fig07.jpg": "220b",
	"./fig08.jpg": "caea",
	"./fig09.jpg": "5a0d",
	"./fig10.jpg": "8582",
	"./fig11.jpg": "6d0d",
	"./fig12.jpg": "5ceb",
	"./fig13.jpg": "e010",
	"./fig14.jpg": "e036",
	"./fig15.jpg": "6c79",
	"./fig16.jpg": "0dfe"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e2cf";